<template>
  <footer class="clearfix">
    <div>
      <p><a title="ICP备案" target="_blank" class="text-muted" href="http://www.beian.miit.gov.cn">
        辽ICP备20003309号
      </a></p>
    </div>
    <div>
      <p>博客内容遵循 <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/deed.zh" target="_blank"
                         rel="noopener">署名-非商业性使用-相同方式共享 4.0 国际 (CC BY-NC-SA 4.0) 协议</a></p>
    </div>
    <div>
      <p>author: <a href="http://blog.devilwst.top" target="_blank" rel="noopener">xiaosheng</a></p>
    </div>
    <div class="copyright">
      <p><a href="http://blog.devilwst.top" target="_blank" rel="noopener">Copyright blog.devilwst.top © 2022 </a>
      </p>
    </div>
  </footer>
</template>
<script>
export default {}

</script>

<style scoped>
.clearfix {
  zoom: 1;
}

footer, footer p {
  font-size: 0.8125rem;
}

footer {
  position: relative;
  padding: 40px 10px 120px 10px;
  width: 100%;
  color: rgba(102, 102, 102, 0.5);
  margin: 0px auto;
  overflow: hidden;
  text-align: center;
}

a {
  color: slategray;
  cursor: pointer;
  text-decoration: none;
}

a:hover {
  color: red;
}
</style>